// removed by extract-text-webpack-plugin
module.exports = {"BrowserHeightSection":"BrowserHeightSection__BrowserHeightSection___ufeAb","BrowserHeightChildren":"BrowserHeightSection__BrowserHeightChildren___2HCdx","BrowserHeightChildrenVisible":"BrowserHeightSection__BrowserHeightChildrenVisible___1CXb8"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/BrowserHeightSection/BrowserHeightSection.less
// module id = 1126
// module chunks = 0 1